import React from 'react';
import StopPropagation from '../utils/StopPropagation';
import Loading, { LoadingBall } from '@ingka/loading';
import styles from './LoadingSpinner.module.less';

export default class LoadingSpinner extends React.Component {
  render() {
    return (
      <StopPropagation className={styles.wrapper}>
        <Loading text="">
          <LoadingBall size="large" color="emphasised" />
        </Loading>
      </StopPropagation>
    );
  }
}
